/** 读取用户选择的文本文件（T07 导入角色卡用）。 */

/**
 * 读取文件文本内容。
 *
 * 优先用标准的 `Blob.text()`；部分老版本 Android WebView 没有实现它，
 * 因此回退到 `FileReader.readAsText` —— 两条路径返回同一份文本。
 */
export function readFileText(file: File): Promise<string> {
  if (typeof file.text === 'function') {
    return file.text();
  }

  return new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      resolve(typeof reader.result === 'string' ? reader.result : '');
    };
    reader.onerror = () => {
      reject(reader.error ?? new Error('读取文件失败'));
    };
    reader.readAsText(file);
  });
}